// console.log('[RebuyUtils] File loading started');
window.RebuyUtils = window.RebuyUtils || {};
// console.log('[RebuyUtils] Object created');

window.RebuyUtils = {
  // Fetch the latest cart data from Rebuy
  fetchCart: async () => {
    try {
      return await window.Rebuy.Cart.getCart();
    } catch (error) {
      console.error('Cart fetch error:', error);
      return null;
    }
  },

  // Find the discount code applied to the cart
  getActiveDiscount: () => {
    return window.Rebuy?.SmartCart?.discount?.discount?.value || 0;
  },

  // Proportional discount allocator function
  allocateDiscountAcrossItems: function (cartItems, discountPercentage) {
    // Special case for single item cart - use direct calculation to avoid rounding issues
    if (cartItems.length === 1) {
      const item = cartItems[0];
      const price = parseFloat(item.price) / 100;
      const itemTotal = price * item.quantity;

      // Calculate discount precisely
      const discountAmount = (itemTotal * discountPercentage) / 100;
      const discountedPrice = itemTotal - discountAmount;

      // Create allocation map with single entry
      const allocations = new Map();
      allocations.set(item.id, {
        originalPrice: itemTotal,
        discountAmount: discountAmount,
        discountedPrice: discountedPrice,
      });

      return {
        allocations,
        totalDiscount: discountAmount,
        discountedTotal: discountedPrice,
      };
    }

    // implementation for multiple items

    // Calculate full subtotal
    const subtotal = cartItems.reduce((sum, item) => {
      const price = parseFloat(item.price) / 100;
      return sum + price * item.quantity;
    }, 0);

    // Calculate total discount amount
    const totalDiscountAmount = Math.round(subtotal * discountPercentage) / 100;

    // Calculate discounted total (what Rebuy will show)
    const discountedTotal = subtotal - totalDiscountAmount;

    // Allocate discount proportionally
    const allocations = new Map();
    let allocatedTotal = 0;
    let allocatedDiscount = 0;

    // First pass: allocate proportional discount to each item and track remainders
    const itemsWithRemainders = [];

    cartItems.forEach(item => {
      const price = parseFloat(item.price) / 100;
      const itemTotal = price * item.quantity;
      const proportion = itemTotal / subtotal;

      // Calculate exact discount
      const exactDiscount = totalDiscountAmount * proportion;

      // Round to 2 decimal places
      const roundedDiscount = Math.floor(exactDiscount * 100) / 100;

      // Store remainder for potential adjustment
      const remainder = exactDiscount - roundedDiscount;
      itemsWithRemainders.push({
        item,
        remainder,
        allocatedDiscount: roundedDiscount,
      });

      // Track running totals
      allocatedDiscount += roundedDiscount;

      // Calculate discounted price
      const discountedPrice = itemTotal - roundedDiscount;
      allocatedTotal += discountedPrice;

      // Store allocation
      allocations.set(item.id, {
        originalPrice: itemTotal,
        discountAmount: roundedDiscount,
        discountedPrice: discountedPrice,
      });
    });

    // Check for rounding error
    const roundingError = totalDiscountAmount - allocatedDiscount;

    if (Math.abs(roundingError) > 0.001) {
      // Sort by remainder (largest first)
      itemsWithRemainders.sort((a, b) => b.remainder - a.remainder);

      // Adjust item with largest remainder
      const adjustItem = itemsWithRemainders[0].item;
      const currentAllocation = allocations.get(adjustItem.id);

      // Apply rounding correction
      const adjustedDiscount = currentAllocation.discountAmount + roundingError;
      const adjustedPrice = currentAllocation.originalPrice - adjustedDiscount;

      // Update allocation
      allocations.set(adjustItem.id, {
        originalPrice: currentAllocation.originalPrice,
        discountAmount: adjustedDiscount,
        discountedPrice: adjustedPrice,
      });
    }

    return {
      allocations,
      totalDiscount: totalDiscountAmount,
      discountedTotal: discountedTotal,
    };
  },

  // Add a gift to the cart
  addGiftToCart: async function (variantId) {
    try {
      // Ensure variant ID is properly formatted
      const cleanVariantId = String(variantId).trim();
      console.log(`[RebuyUtils] Adding gift to cart, variant ID: ${cleanVariantId}`);

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [
            {
              id: cleanVariantId,
              quantity: 1,
              properties: {
                _free_gift_source: 'bwb_code',
              },
            },
          ],
        }),
      });

      // Check if response is ok
      if (!response.ok) {
        const errorText = await response.text();
        console.error(`[RebuyUtils] Cart API error (${response.status}):`, errorText);
        return { error: errorText };
      }

      const responseData = await response.json();
      console.log(`[RebuyUtils] Gift added successfully:`, responseData);
      return responseData;
    } catch (error) {
      console.error('[RebuyUtils] Add gift error:', error);
      return { error: error.message };
    }
  },

  // Remove an item from the cart
  removeItemFromCart: async function (itemKey) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: { [itemKey]: 0 } }),
      });
      return await response.json();
    } catch (error) {
      console.error('[RebuyUtils] Remove item error:', error);
      return null;
    }
  },

  // set quantity of an item manually (used to enforce only 1 instance of a free gift)
  setItemQuantity: async function (itemKey, quantity) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: { [itemKey]: quantity } }),
      });
      return await response.json();
    } catch (error) {
      console.error('[RebuyUtils] Update item error:', error);
      return null;
    }
  },
};
